<!--
 * @Date: 2023-09-06 14:44:03

-->
<template>
<bk-scroll-list 
  ref="listScroll" 
  :beforeSearch="beforeSearch" 
  :async-load-data="requestPostShopList" 
  langCode_description="bkShopSearch_description"
>
  <template v-slot="{ dataList, total }">
    <bk-view class="shopList-container">
      <bk-title>{{$bk_lang['bkShopSearch_results']}}({{total}})</bk-title>
      <bk-view class="view-shop-list">
        <bk-view class="view-shop-item" v-for="item in dataList" :key="item.compId" @click="handleItemClick(item,'shopItem')">
          <bk-image :src="item.pictureFacade" />
          <bk-view class="view-title">{{ item.compName }}</bk-view>
          <bk-view class="view-address">
            <bk-icon icon="icon-dizhi"></bk-icon>{{item.address}}
          </bk-view>
          <bk-view class="view-server-list" v-if="item.projectList.length">
            <bk-view class="view-server-item" v-for="projectItem in  item.projectList" :key="projectItem.id">
              <bk-view class="view-server-left">
                <bk-view class="view-name">{{projectItem.name}}</bk-view>
                <bk-view class="view-consume">
                  <bk-price v-if="projectItem.price" :unitText="item.currencySymbol" :value="projectItem.price"></bk-price>
                  <bk-view class="view-date">
                    <bk-view>{{projectItem.duration || 0}}</bk-view>
                    <bk-lang code="bkShopSearch_min"></bk-lang>
                  </bk-view>
                </bk-view>
              </bk-view>
              <bk-view>
                <bk-button langCode="bkShopSearch_book" @click.stop="handleItemClick(projectItem,'reserve')"></bk-button>
              </bk-view>
            </bk-view>
          </bk-view>
        </bk-view>
      </bk-view>
    </bk-view>
  </template>
</bk-scroll-list>
 
</template>

<script>
	import { reportReq } from '@/reqService';


	export default {
		name:'shopList',
		props:{
			keyword:String,
			locInfo:Object
		},
		data (){
			return {
				userInfo:this.$bk_getUserInfo()
			};
		},
		methods:{
			reloadData (){
				this.$refs.listScroll.reloadData();
			},
			beforeSearch (params){
				params = Object.assign(params, {
					keyword:this.keyword,
					// lng:121.362976,
					// lat:31.129796,
				});

				if(this.locInfo){
					params.lng = this.locInfo.lng;
					params.lat = this.locInfo.lat;
				}

				if(this.userInfo?.userId){
					params.userId = this.userInfo?.userId;
				}

				return params;
			},
			async requestPostShopList (params){
				const res = await reportReq.requestPostShopList(this, params);
				return { data: res?.list, total:res?.page?.total };
			},
			handleItemClick (row, key){
				this.$emit('handleItemClick', {row, key });
			}
		}
	};
</script>

<style lang="less">
@import './shopList.less';
</style>